module.exports = __webpack_public_path__ + "static/media/allinone_5.67db1745.svg";